import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function LineArrowUpDownIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="m21 16-4 4-4-4" />
      <path d="M17 20V4" />
      <path d="m3 8 4-4 4 4" />
      <path d="M7 4v16" />
    </StrokeIcon>
  );
}
